import Container from './StudioBreadcrumbs.container';
import StudioBreadcrumbs from './StudioBreadcrumbs';

export default Container(StudioBreadcrumbs);
